<div [style.height.px]="height" class="blank-chart">
    <div [style.padding-top.px]="height/2 - 30" class="instruction-text">{{'wbo.bi-dashboard.edit.field-set.drop-field-here' | translate}}</div>
</div>
